import {
  Action,
  Reducer,
} from 'redux';

import { processContentString } from '../../utils/content-processing';
import {
  PartialStateAction,
  RESULTS_LOAD_BEGIN,
  RESULTS_LOADED,
} from '../app/actions';
import State, {
  Content,
  Default,
} from './state';

const processContent = (state: State | undefined): State | undefined => {
  if (!state) return state;

  let newLibrary: Record<string, Content> = {};
  Object.keys(state.contentLibrary).forEach((key) => {
    let value = state.contentLibrary[key];
    let updatedValue = value.map((entry) => {
      var entryCopy = Object.assign({}, entry);
      if (entryCopy.typeOfContent === "HtmlContent")
        entryCopy.content = processContentString(entryCopy.content);
      else if (entryCopy.typeOfContent === "MultipleChoiceResponseContent")
        entryCopy.options = entryCopy.options.map((op) => ({
          id: op.id,
          label: op.label,
          content: processContentString(op.content),
        }));

      return entryCopy;
    });
    newLibrary[key] = updatedValue;
  });

  return { ...state, contentLibrary: newLibrary };
};

const reducer: Reducer<State, Action> = (state, action) => {
  if (!state) return Default;

  switch (action.type) {
    case RESULTS_LOAD_BEGIN:
      return Default;
    case RESULTS_LOADED:
      let newState = processContent(
        (action as PartialStateAction).newState.itemContent
      );
      if (newState) return { ...newState };
      return state;
    default:
      return state;
  }
};

export default reducer;
